import config from "@/config";
import useDialog from "./useDialog";
import {ModalTransition, ShareDialog} from "@/Components";

export default function useShareDialog(){

    const { forceClose, toggleDialog } = useDialog();

    const toggleShareDialog = (event, data) => {
        toggleDialog(ShareDialog, ModalTransition, data, event, config.dialogs.drawers.productSearchDialog.zindex, true);
    };

    return {
        forceClose,
        toggleShareDialog,
    };

};
